module.exports = __webpack_public_path__ + "img/picpay.122c5746.svg";